import store from "@/controller/baseController";
import Enums from "../enums/enums";
import peakUtility from "../function/peakUtility";
import merchantHelper from "./merchantHelper";
import { GetReferenceDepositSummary, GetTransactionItemList, GetTransactionItemSummary } from "./transactionItemHelper";
function GetCreateTransactionPaymentDefualt(isPaymentActive = true) {
  let payment = {
    hidden: false,
    disabled: false,
    paymentOptionDisabled: false,
    isValidateError: false,
    paymentGroupList: [],
    paymentAllGroupTotal: 0,
    isDisabledByStatement: false,
  };
  payment.paymentGroupList.push(GetCreateTransactionPaymentGroupDefualt(isPaymentActive));
  return payment;
}

function GetCreateTransactionPaymentGroupDefualt(isPaymentActive = true) {
  let paymentGroup = {
    id: 0,
    isPaymentActive: isPaymentActive,
    validateError: false,
    paymentGroupNumber: 0,
    paymentGroupDate: new Date(),
    withdrawalTransactionBankAccountList: [],
    depositTranctionBankAccountList: [],
    paymentTransactionBankAccountList: [],
    paymentTransactionChartOfAccountList: [],
    paymentTransactionDocumentList: [],
    paymentTransactionBankAccountDisabled: false,
    paymentTransactionBankAccountHidden: false,
    paymentTransactionBankAccountActived: true,
    paymentTransactionChartAccountDisabled: false,
    paymentTransactionChartAccountHidden: true,
    paymentTransactionChartAccountActived: false,
    paymentTransactionDocumentDisabled: false,
    paymentTransactionDocumentHidden: true,
    paymentTransactionDocumentActived: false,
    disabled: false,
    hidden: false,
    eWhtType: Enums.EWhtType.Normal,
    paymentInOutFlowType: Enums.PaymentInOutFlowType.CashIn,
    whtPayment: {
      id: 0,
      isWht: false,
      pndTypeId: 0,
      whtAmountTypeId: 0,
      whtAmount: 0,
      disabled: false,
      hidden: false,
      whtDeductType: Enums.WhtDeductType.WitholdAtSource,
    },
    eWhtData: {
      id: 0,
      isWht: false,
      pndTypeId: 0,
      whtAmountTypeId: 0,
      whtAmount: 0,
      disabled: false,
      hidden: false,
      whtDeductType: Enums.WhtDeductType.WitholdAtSource,
    },
    paymentTransactionBankAccountTotal: 0,
    paymentTransactionChartAccountTotal: 0,
    paymentTransactionDocumentTotal: 0,
    paymentGroupTotal: 0,
    paymentGroupWhtTotal: 0,
    paymentGroupTotalWithOutWht: 0,
    paymentTransactionBankAccountTotalWithWht: 0,
    paymentOption: Enums.PaymentOption.Standard,
    paymentTransactionBankAccountTempList: [],
  };
  paymentGroup.paymentTransactionBankAccountList.push(GetCreatePaymentTransactionBankAccountDefault());
  paymentGroup.paymentTransactionChartOfAccountList.push(GetCreatePaymentTransactionChartAccountDefault());
  paymentGroup.paymentTransactionDocumentList.push(GetCreatePaymentTransactionDocumentDefault());
  return paymentGroup;
}
function GetCreatePaymentTransactionBankAccountDefault() {
  let paymentTransactionBankAccount = {
    id: 0,
    bankAccountId: 0,
    bankAccountCode: "",
    bankAccountName: "",
    paymentAmount: "0.00",
    remark: "",
    isCheque: false,
    cheque: {
      id: 0,
      chequeNumber: "",
      chequeDate: Date().ToDateJsonString(),
      branchNumber: "",
      accountNumber: "",
      chequeBankId: 0,
      createPaymentDate: new Date().ToDateJsonString(),
    },
    inputValidationError: false,
    paymentAmountValidationError: false,
    disableBankAccount: false,
    disablePaymentAmount: false,
  };
  return paymentTransactionBankAccount;
}
function GetCreatePaymentTransactionChartAccountDefault() {
  let paymentTransactionChartAccount = {
    id: 0,
    accountId: 0,
    accountReferenceTypeId: 0,
    accountReferenceId: 0,
    accountReferenceCode: "",
    accountCode: "",
    accountName: "",
    paymentAmount: "0.00",
    remark: "",
    adjustValue: Enums.TransferFeeDeductType.DepositeAccount,
    inputValidationError: false,
    paymentAmountValidationError: false,
  };
  return paymentTransactionChartAccount;
}
function GetCreatePaymentTransactionDocumentDefault() {
  let paymentTransactionDocument = {
    id: 0,
    transactionId: 0,
    transactionNumber: "",
    transactionNumberDisabled: false,
    transactionValidationError: false,
    transactionIsNotAuto: false,
    transactionRemainPayment: 0,
    paymentInOutFlowType: 0,
    transactionType: {
      value: 0,
    },
    transactionTypeDisabled: false,
    paymentAmount: "0.00",
    paymentAmountValidationError: false,
    remark: "",
  };
  return paymentTransactionDocument;
}
function GetCreatePaymentCheque() {
  let paymentCheque = {
    chequeNumber: "",
    chequeDate: Date(),
    branchNumber: "",
    accountNumber: "",
    chequeBankId: 0,
    createPaymentDate: new Date().ToDateJsonString(),
  };
  return paymentCheque;
}
function CalculateAllPaymentGroupSummary(payment) {
  payment.paymentAllGroupTotal = 0;
  if (payment.paymentGroupList) {
    payment.paymentGroupList.forEach((paymentGroup) => {
      if (paymentGroup.isPaymentActive) {
        CalculatePaymentGroupSummary(paymentGroup);
        payment.paymentAllGroupTotal = peakUtility.PeakOperatorAdd(
          payment.paymentAllGroupTotal,
          paymentGroup.paymentGroupTotal
        );
        paymentGroup.validateError = ValidationPaymentGroup(paymentGroup, false);
      }
    });
  }
}

function ValidateWhtForPayment(pndTypeId, contactTypeId, whtDeductType) {
  var isHaveError = true;
  switch (contactTypeId) {
    case Enums.MerchantType.LimitedLiabilityPartnership:
    case Enums.MerchantType.CompanyLimited:
    case Enums.MerchantType.PublicCompanyLimited:
    case Enums.MerchantType.Others:
    case Enums.MerchantType.Foundation:
    case Enums.MerchantType.Association:
    case Enums.MerchantType.JointVenture:
      if (pndTypeId === Enums.PndType.PND53 || pndTypeId === Enums.PndType.PND54) {
        isHaveError = false;
      }
      break;
    case Enums.MerchantType.Shop:
    case Enums.MerchantType.OrdinaryPerson:
    case Enums.MerchantType.BodyOfPersons:
    case Enums.MerchantType.OrdinaryPartnership:
      if (
        pndTypeId === Enums.PndType.PND2 ||
        pndTypeId === Enums.PndType.PND2Specialkor ||
        pndTypeId === Enums.PndType.PND2kor ||
        pndTypeId === Enums.PndType.PND3 ||
        pndTypeId === Enums.PndType.PND3kor ||
        pndTypeId === Enums.PndType.PND1
      ) {
        isHaveError = false;
      }
      break;
  }

  if (!whtDeductType) {
    isHaveError = true;
  }

  return isHaveError;
}

function CheckTransactionTypeForWhtModel(transactionType, financeType) {
  var isCanCreateWht = false;
  if (
    financeType === Enums.FinanceType.OutFlow &&
    (transactionType === Enums.TransactionType.Invoice || transactionType === Enums.TransactionType.BillingNote)
  ) {
    isCanCreateWht = true;
  } else if (financeType === Enums.FinanceType.InFlow && transactionType === Enums.TransactionType.CreditNote) {
    isCanCreateWht = true;
  }
  return isCanCreateWht;
}

function ValidationAllPaymentGroup(transaction, transactionType, financeType) {
  if (transaction.payment.paymentGroupList) {
    let paymentTotal = 0;
    let netAmountBankAccountTotal = 0;
    let netAmountWithDrawalChartOfAccountTotal = 0;
    transaction.payment.paymentGroupList.forEach((paymentGroup) => {
      if (paymentGroup.isPaymentActive) {
        paymentTotal += paymentGroup.paymentGroupTotal.ToNumber();
        paymentGroup.validateError = ValidationPaymentGroup(paymentGroup, true);
        if (
          !paymentGroup.validateError &&
          paymentGroup.whtPayment.isWht &&
          paymentGroup.whtPayment.whtAmount.ToNumber() != 0 &&
          CheckTransactionTypeForWhtModel(transactionType, financeType)
        ) {
          paymentGroup.validateError = ValidateWhtForPayment(
            paymentGroup.whtPayment.pndTypeId,
            transaction.contact.contactType,
            paymentGroup.whtPayment.whtDeductType
          );
        }
        if (paymentGroup.validateError) {
          transaction.payment.isValidateError = true;
        }

        paymentGroup.paymentTransactionBankAccountList.forEach((paymentTransactionBankAccount) => {
          netAmountBankAccountTotal += paymentTransactionBankAccount.paymentAmount.ToNumber();
        });

        paymentGroup.paymentTransactionChartOfAccountList.forEach((paymentChartOfAccount) => {
          if (paymentChartOfAccount.adjustValue == Enums.TransferFeeDeductType.WithDrawalAccount) {
            netAmountWithDrawalChartOfAccountTotal += paymentChartOfAccount.paymentAmount.ToNumber();
          }
        });
      }
    });
    if (
      paymentTotal.ToAccountingRoundUpNumber() >
      transaction.transactionSummary.netAmount.ToNumber().ToAccountingRoundUpNumber()
    ) {
      transaction.payment.isValidateError = true;
    }

    if (transactionType === Enums.TransactionType.Receipt && transaction.reference.referenceId > 0) {
      let paymentAmountRemaining = peakUtility
        .PeakOperatorSubtract(transaction.transactionSummary.netAmount, transaction.payment.paymentAllGroupTotal)
        .ToAccountingRoundUpNumber();
      transaction.payment.paymentGroupList.forEach((paymentGroup) => {
        paymentGroup.paymentTransactionBankAccountList.forEach((paymentTransactionBankAccount) => {
          if (paymentTransactionBankAccount.paymentAmount.ToNumber() <= 0 || paymentAmountRemaining < 0) {
            paymentTransactionBankAccount.paymentAmountValidationError = true;
          } else {
            paymentTransactionBankAccount.paymentAmountValidationError = false;
          }
        });
      });
    }

    if (transactionType === Enums.TransactionType.CreditNote && transaction.reference.referenceId > 0) {
      let creditNoteWaitingPaidTotal = transaction.creditNoteWaitingPaidTotal
        ? transaction.creditNoteWaitingPaidTotal.value.ToNumber()
        : 0;
      let netAmountBankAccountValidateError =
        netAmountBankAccountTotal - netAmountWithDrawalChartOfAccountTotal > creditNoteWaitingPaidTotal;
      if (netAmountBankAccountValidateError) {
        transaction.payment.isValidateError = true;
        transaction.payment.paymentGroupList.forEach((paymentGroup) => {
          paymentGroup.paymentTransactionBankAccountList.forEach((paymentTransactionBankAccount) => {
            paymentTransactionBankAccount.paymentAmountValidationError = true;
          });
        });
      }
    }
  }
}
function ValidationPaymentGroup(paymentGroup, isShowError = true) {
  let paymentGroupChartAccountValidateError = false;
  if (paymentGroup.paymentTransactionChartAccountActived) {
    paymentGroup.paymentTransactionChartOfAccountList.forEach((paymentTransactionChartAccount) => {
      if (paymentTransactionChartAccount.accountId == 0) {
        if (isShowError) {
          paymentTransactionChartAccount.inputValidationError = true;
        }
        paymentGroupChartAccountValidateError = true;
      } else {
        paymentTransactionChartAccount.inputValidationError = false;
      }
      if (paymentTransactionChartAccount.paymentAmount.ToNumber() < 0) {
        paymentTransactionChartAccount.paymentAmountValidationError = true;
        paymentGroupChartAccountValidateError = true;
      } else {
        paymentTransactionChartAccount.paymentAmountValidationError = false;
      }
    });
  }
  let paymentGroupTransactionDocumentValidateError = false;
  if (paymentGroup.paymentTransactionDocumentActived && !paymentGroup.disabled) {
    paymentGroup.paymentTransactionDocumentList.forEach((paymentTransactionDocument) => {
      if (paymentTransactionDocument.transactionId == 0) {
        if (isShowError) {
          paymentTransactionDocument.paymentAmountValidationError = true;
        }
        paymentGroupTransactionDocumentValidateError = true;
      } else {
        paymentTransactionDocument.paymentAmountValidationError =
          paymentTransactionDocument.paymentAmount.ToNumber() >
          paymentTransactionDocument.transactionRemainPayment.ToNumber();

        if (paymentTransactionDocument.paymentAmountValidationError) {
          paymentGroupTransactionDocumentValidateError = true;
        } else {
          if (paymentTransactionDocument.paymentAmount.ToNumber() < 0) {
            paymentTransactionDocument.paymentAmountValidationError = true;
            paymentGroupTransactionDocumentValidateError = true;
          } else {
            paymentTransactionDocument.paymentAmountValidationError = false;
          }
        }
      }
    });
  }
  let paymentGroupBankAccountValidateError = false;
  paymentGroup.paymentTransactionBankAccountList.forEach((paymentTransactionBankAccount) => {
    if (
      paymentTransactionBankAccount.bankAccountId == 0 &&
      !paymentTransactionBankAccount.isCheque &&
      paymentTransactionBankAccount.paymentAmount.ToNumber() > 0
    ) {
      paymentGroupBankAccountValidateError = true;
      if (isShowError) {
        paymentTransactionBankAccount.inputValidationError = true;
      }
    } else {
      paymentTransactionBankAccount.inputValidationError = false;
    }
    if (paymentTransactionBankAccount.paymentAmount.ToNumber() < 0) {
      paymentTransactionBankAccount.paymentAmountValidationError = true;
      paymentGroupBankAccountValidateError = true;
    } else {
      paymentTransactionBankAccount.paymentAmountValidationError = false;
    }
  });
  return (
    paymentGroupBankAccountValidateError ||
    paymentGroupChartAccountValidateError ||
    paymentGroupTransactionDocumentValidateError
  );
}
function CalculatePaymentGroupSummary(paymentGroup) {
  paymentGroup.paymentTransactionBankAccountTotal = 0;
  paymentGroup.paymentTransactionChartAccountTotal = 0;
  paymentGroup.paymentTransactionDocumentTotal = 0;
  if (paymentGroup.paymentTransactionBankAccountList) {
    paymentGroup.paymentTransactionBankAccountList.forEach((paymentTransaction) => {
      paymentGroup.paymentTransactionBankAccountTotal = peakUtility.PeakOperatorAdd(
        paymentGroup.paymentTransactionBankAccountTotal,
        paymentTransaction.paymentAmount.ToNumber()
      );
    });
  }
  if (paymentGroup.paymentTransactionChartAccountActived && paymentGroup.paymentTransactionChartOfAccountList) {
    paymentGroup.paymentTransactionChartOfAccountList.forEach((paymentTransaction) => {
      paymentGroup.paymentTransactionChartAccountTotal = peakUtility.PeakOperatorAdd(
        paymentGroup.paymentTransactionChartAccountTotal,
        peakUtility.PeakOperatorMultiply(
          paymentTransaction.adjustValue == Enums.TransferFeeDeductType.WithDrawalAccount ? -1 : 1,
          paymentTransaction.paymentAmount.ToNumber()
        )
      );
    });
  }
  if (paymentGroup.paymentTransactionDocumentActived && paymentGroup.paymentTransactionDocumentList) {
    paymentGroup.paymentTransactionDocumentList.forEach((paymentTransaction) => {
      paymentGroup.paymentTransactionDocumentTotal = peakUtility.PeakOperatorAdd(
        paymentGroup.paymentTransactionDocumentTotal,
        paymentTransaction.paymentAmount.ToNumber()
      );
    });
  }

  paymentGroup.paymentGroupWhtTotal = paymentGroup.whtPayment.isWht ? paymentGroup.whtPayment.whtAmount : 0;
  let paymentGroupTotal = peakUtility.PeakOperatorAdd(
    peakUtility.PeakOperatorAdd(
      paymentGroup.paymentTransactionBankAccountTotal,
      paymentGroup.paymentTransactionChartAccountTotal
    ),
    peakUtility.PeakOperatorAdd(paymentGroup.paymentTransactionDocumentTotal, paymentGroup.paymentGroupWhtTotal)
  );
  paymentGroup.paymentGroupTotal = paymentGroupTotal;
  paymentGroup.paymentGroupTotalWithOutWht = peakUtility.PeakOperatorSubtract(
    paymentGroup.paymentGroupTotal,
    paymentGroup.paymentGroupWhtTotal
  );
  paymentGroup.paymentTransactionBankAccountTotalWithWht = peakUtility.PeakOperatorAdd(
    paymentGroup.paymentTransactionBankAccountTotal,
    paymentGroup.paymentGroupWhtTotal
  );
}
function GetWhtPercentFromWhtAmountType(whtAmountTypeId) {
  let whtPercent = 0;
  switch (whtAmountTypeId) {
    case Enums.WhtAmountType.ZeroPointSevenFive.type:
      whtPercent = Enums.WhtAmountType.ZeroPointSevenFive.value;
      break;
    case Enums.WhtAmountType.OnePercent.type:
      whtPercent = Enums.WhtAmountType.OnePercent.value;
      break;
    case Enums.WhtAmountType.OnePointFivePercent.type:
      whtPercent = Enums.WhtAmountType.OnePointFivePercent.value;
      break;
    case Enums.WhtAmountType.TwoPercent.type:
      whtPercent = Enums.WhtAmountType.TwoPercent.value;
      break;
    case Enums.WhtAmountType.ThreePercent.type:
      whtPercent = Enums.WhtAmountType.ThreePercent.value;
      break;
    case Enums.WhtAmountType.FivePercent.type:
      whtPercent = Enums.WhtAmountType.FivePercent.value;
      break;
    case Enums.WhtAmountType.TenPercent.type:
      whtPercent = Enums.WhtAmountType.TenPercent.value;
      break;
    case Enums.WhtAmountType.FifteenPercent.type:
      whtPercent = Enums.WhtAmountType.FifteenPercent.value;
      break;
    case Enums.whtAmount.None.type:
      whtPercent = Enums.whtAmountType.None.value;
      break;
  }
  return whtPercent;
}
function CalculateWhtAmount(transactionNetAmount, subTotalForCalculateWht, paymentGroup) {
  if (paymentGroup.whtPayment.isWht) {
    if (paymentGroup.whtPayment.whtAmountTypeId !== Enums.WhtAmountType.Custom.type) {
      let whtPercent = GetWhtPercentFromWhtAmountType(paymentGroup.whtPayment.whtAmountTypeId);
      let whtAmount = CalculateWhtByPercent(
        transactionNetAmount,
        subTotalForCalculateWht,
        paymentGroup.paymentGroupTotal,
        whtPercent
      );
      paymentGroup.whtPayment.whtAmount = whtAmount.FormatMoney();
    }
  } else {
    if (
      paymentGroup.eWhtType == Enums.EWhtType.EWht &&
      paymentGroup.eWhtData.whtAmountTypeId !== Enums.WhtAmountType.Custom.type
    ) {
      let whtPercent = GetWhtPercentFromWhtAmountType(paymentGroup.eWhtData.whtAmountTypeId);
      let eWhtAmount = CalculateWhtByPercent(
        transactionNetAmount,
        subTotalForCalculateWht,
        paymentGroup.paymentGroupTotal,
        whtPercent
      );
      paymentGroup.eWhtData.whtAmount = eWhtAmount.FormatMoney();
    }
  }
}
function CalculateWhtByPercent(transactionNetAmount, subTotalForCalculateWht, paymentNetAmount, whtPercent) {
  let whtAmount = 0;
  let whtDeductType = Enums.WhtDeductType.WitholdAtSource;
  switch (whtDeductType) {
    case Enums.WhtDeductType.PayEveryTime:
      whtAmount = 0;
      break;
    case Enums.WhtDeductType.PayOneTime:
      whtAmount = 0;
      break;
    default:
      if (paymentNetAmount != 0 && transactionNetAmount != 0) {
        whtAmount = peakUtility.PeakOperatorMultiply(
          peakUtility.PeakOperatorDivide(paymentNetAmount, transactionNetAmount),
          peakUtility.PeakOperatorDivide(peakUtility.PeakOperatorMultiply(subTotalForCalculateWht, whtPercent), 100)
        );
      }
      break;
  }
  return whtAmount;
}
function OnChangeWht(paymentGroup, isFromEvent = false, isReturnWhtAmountToPayment = false) {
  const paymentTransactionBankAccountIndex = 0;

  if (paymentGroup.whtPayment.isWht) {
    if (!paymentGroup.paymentTransactionBankAccountDisabled) {
      if (paymentGroup.paymentTransactionBankAccountList[paymentTransactionBankAccountIndex]) {
        paymentGroup.paymentTransactionBankAccountList[paymentTransactionBankAccountIndex].paymentAmount = peakUtility
          .PeakOperatorSubtract(
            paymentGroup.paymentTransactionBankAccountList[paymentTransactionBankAccountIndex].paymentAmount,
            paymentGroup.whtPayment.whtAmount
          )
          .FormatMoney();
      }
    }
  } else {
    if (!paymentGroup.paymentTransactionBankAccountDisabled) {
      if (paymentGroup.paymentTransactionBankAccountList[paymentTransactionBankAccountIndex]) {
        paymentGroup.paymentTransactionBankAccountList[paymentTransactionBankAccountIndex].paymentAmount = peakUtility
          .PeakOperatorAdd(
            paymentGroup.paymentTransactionBankAccountList[paymentTransactionBankAccountIndex].paymentAmount,
            paymentGroup.whtPayment.whtAmount
          )
          .FormatMoney();
      }
    }

    if (isFromEvent) {
      paymentGroup.whtPayment.whtAmount = 0;
    }
  }
}
function IsTransactionCanUsePndType(transactionTypeId, financeTypeId) {
  var isTransactionCanUsePndType = false;
  if (transactionTypeId === Enums.TransactionType.Invoice && financeTypeId === Enums.FinanceType.OutFlow) {
    isTransactionCanUsePndType = true;
  } else if (transactionTypeId === Enums.TransactionType.BillingNote && financeTypeId === Enums.FinanceType.OutFlow) {
    isTransactionCanUsePndType = true;
  } else if (transactionTypeId === Enums.TransactionType.CreditNote && financeTypeId === Enums.FinanceType.InFlow) {
    isTransactionCanUsePndType = true;
  } else if (transactionTypeId === Enums.TransactionType.DebitNote && financeTypeId === Enums.FinanceType.OutFlow) {
    isTransactionCanUsePndType = true;
  } else if (transactionTypeId === Enums.TransactionType.Deposit && financeTypeId === Enums.FinanceType.OutFlow) {
    isTransactionCanUsePndType = true;
  } else if (transactionTypeId === Enums.TransactionType.InvoiceReceipt) {
    isTransactionCanUsePndType = true;
  }
  return isTransactionCanUsePndType;
}
function GetSuggestionPndType(transaction, accountListForMap) {
  let pndType = Enums.PndType.None;
  if (IsTransactionCanUsePndType(transaction.transactionType, transaction.financeType)) {
    if (merchantHelper.IsOrdinaryPerson(transaction.contact.contactType)) {
      let totalPndType3 = 0;
      let totalPndType2 = 0;
      let totalPndType1Kor = 0;
      if (transaction.transactionType != Enums.TransactionType.BillingNote) {
        const referenceDepositSummary = GetReferenceDepositSummary(transaction);
        const transactionItemModel = GetTransactionItemList(transaction);
        const transactionItemSummary = GetTransactionItemSummary(
          transaction,
          transactionItemModel,
          referenceDepositSummary
        );
        for (let transactionItem of transactionItemModel.transactionItemList) {
          if (!transactionItem.isDescriptionOnly && transactionItem.accountid > 0) {
            const account = accountListForMap.get(transactionItem.accountid);
            if (account) {
              var transactionItemPndType = GetPndTypeByTaxIncomeType(account.taxIncomeTypeId);
              if (transactionItemSummary.isNoneOrNotSpecifyWht) {
                if (transactionItemPndType === Enums.PndType.PND1) {
                  totalPndType1Kor += transactionItem.toCurrencyNetTotal;
                } else if (transactionItemPndType === Enums.PndType.PND2) {
                  totalPndType2 += transactionItem.toCurrencyNetTotal;
                } else if (transactionItemPndType === Enums.PndType.PND3) {
                  totalPndType3 += transactionItem.toCurrencyNetTotal;
                }
              } else {
                if (transactionItemPndType === Enums.PndType.PND1) {
                  totalPndType1Kor += transactionItem.whtAmount;
                } else if (transactionItemPndType === Enums.PndType.PND2) {
                  totalPndType2 += transactionItem.whtAmount;
                } else if (transactionItemPndType === Enums.PndType.PND3) {
                  totalPndType3 += transactionItem.whtAmount;
                }
              }
            }
          }
        }
      } else {
        for (let transactionItem of transaction.transactionItemList) {
          if (
            transactionItem.billingNoteTransactionItemList &&
            transactionItem.billingNoteTransactionItemList.length > 0
          ) {
            for (let billingNoteTransactionItem of transactionItem.billingNoteTransactionItemList) {
              if (!billingNoteTransactionItem.isDescriptionOnly && billingNoteTransactionItem.accountId > 0) {
                const account = accountListForMap.get(billingNoteTransactionItem.accountId);
                if (account) {
                  var transactionItemPndType = GetPndTypeByTaxIncomeType(account.taxIncomeTypeId);
                  if (
                    transaction.transactionSummary.isNoneOrNotSpecifyWht &&
                    billingNoteTransactionItem.toCurrencyNetTotal
                  ) {
                    if (transactionItemPndType === Enums.PndType.PND1) {
                      totalPndType1Kor += billingNoteTransactionItem.toCurrencyNetTotal.ToNumber();
                    } else if (
                      transactionItemPndType === Enums.PndType.PND2 &&
                      billingNoteTransactionItem.toCurrencyNetTotal
                    ) {
                      totalPndType2 += billingNoteTransactionItem.toCurrencyNetTotal.ToNumber();
                    } else if (
                      transactionItemPndType === Enums.PndType.PND3 &&
                      billingNoteTransactionItem.toCurrencyNetTotal
                    ) {
                      totalPndType3 += billingNoteTransactionItem.toCurrencyNetTotal.ToNumber();
                    }
                  } else {
                    if (
                      transactionItemPndType === Enums.PndType.PND1 &&
                      billingNoteTransactionItem.toCurrencyWHTTotal
                    ) {
                      totalPndType1Kor += billingNoteTransactionItem.toCurrencyWHTTotal.ToNumber();
                    } else if (
                      transactionItemPndType === Enums.PndType.PND2 &&
                      billingNoteTransactionItem.toCurrencyWHTTotal
                    ) {
                      totalPndType2 += billingNoteTransactionItem.toCurrencyWHTTotal.ToNumber();
                    } else if (
                      transactionItemPndType === Enums.PndType.PND3 &&
                      billingNoteTransactionItem.toCurrencyWHTTotal
                    ) {
                      totalPndType3 += billingNoteTransactionItem.toCurrencyWHTTotal.ToNumber();
                    }
                  }
                }
              }
            }
          }
        }
      }
      if (totalPndType3 < totalPndType1Kor && totalPndType2 <= totalPndType1Kor) {
        pndType = Enums.PndType.PND1;
      } else if (totalPndType2 > totalPndType1Kor && totalPndType2 > totalPndType3) {
        pndType = Enums.PndType.PND2;
      } else {
        pndType = Enums.PndType.PND3;
      }
    } else {
      pndType = Enums.PndType.PND53;
    }
  }
  return pndType;
}
function GetPndTypeByTaxIncomeType(taxIncomeTypeId) {
  let pndType = Enums.PndType.PND3;
  switch (taxIncomeTypeId) {
    case Enums.TaxIncomeType.TaxIncomeType40_1_1:
    case Enums.TaxIncomeType.TaxIncomeType40_1_2:
    case Enums.TaxIncomeType.TaxIncomeType40_12:
    case Enums.TaxIncomeType.TaxIncomeType40_2:
      pndType = Enums.PndType.PND1;
      break;
    case Enums.TaxIncomeType.TaxIncomeType40_3:
    case Enums.TaxIncomeType.TaxIncomeType40_4_A:
    case Enums.TaxIncomeType.TaxIncomeType40_4_B:
    case Enums.TaxIncomeType.TaxIncomeType40_4_C:
    case Enums.TaxIncomeType.TaxIncomeType40_4_D:
    case Enums.TaxIncomeType.TaxIncomeType40_4_E:
    case Enums.TaxIncomeType.TaxIncomeType40_4_F:
    case Enums.TaxIncomeType.TaxIncomeType40_4_G:
      pndType = Enums.PndType.PND2;
      break;
  }
  return pndType;
}
function GetPaymentInOutFlowType(transactionType, financeType) {
  let paymentInOutFlowType = Enums.PaymentInOutFlowType.CashIn;
  if (
    (transactionType === Enums.TransactionType.CreditNote && financeType === Enums.FinanceType.InFlow) ||
    (transactionType !== Enums.TransactionType.CreditNote && financeType === Enums.FinanceType.OutFlow)
  ) {
    paymentInOutFlowType = Enums.PaymentInOutFlowType.CashOut;
  }
  return paymentInOutFlowType;
}
function GetPaymentWhtOption() {
  return [
    {
      name: "0.75%",
      value: Enums.WhtAmountType.ZeroPointSevenFive.value,
      type: Enums.WhtAmountType.ZeroPointSevenFive.type,
    },
    { name: "1%", value: Enums.WhtAmountType.OnePercent.value, type: Enums.WhtAmountType.OnePercent.type },
    {
      name: "1.5%",
      value: Enums.WhtAmountType.OnePointFivePercent.value,
      type: Enums.WhtAmountType.OnePointFivePercent.type,
    },
    { name: "2%", value: Enums.WhtAmountType.TwoPercent.value, type: Enums.WhtAmountType.TwoPercent.type },
    { name: "3%", value: Enums.WhtAmountType.ThreePercent.value, type: Enums.WhtAmountType.ThreePercent.type },
    { name: "5%", value: Enums.WhtAmountType.FivePercent.value, type: Enums.WhtAmountType.FivePercent.type },
    { name: "10%", value: Enums.WhtAmountType.TenPercent.value, type: Enums.WhtAmountType.TenPercent.type },
    {
      name: "15%",
      value: Enums.WhtAmountType.FifteenPercent.value,
      type: Enums.WhtAmountType.FifteenPercent.type,
    },
    { name: "กำหนดเอง", value: Enums.WhtAmountType.Custom.value, type: Enums.WhtAmountType.Custom.type },
  ];
}
function GetWhtPaymentPercent(subTotalForCalculateWht, transactionWhtTotal, transactionNetAmount, paymentNetAmount) {
  let whtPercentList = GetPaymentWhtOption();
  let whtAmountList = [];
  for (let whtPercent of whtPercentList) {
    if (whtPercent.type !== Enums.WhtAmountType.Custom.type) {
      let _currentWHTAmount = (
        peakUtility.PeakOperatorDivide(paymentNetAmount, transactionNetAmount) *
        peakUtility.PeakOperatorDivide(peakUtility.PeakOperatorMultiply(subTotalForCalculateWht, whtPercent.value), 100)
      ).ToAccountingRoundUp();
      whtAmountList.push({ whtType: whtPercent.type, amount: _currentWHTAmount });
    }
  }
  let whtAmountType = Enums.WhtAmountType.Custom.type;
  for (let whtAmount of whtAmountList) {
    if (
      !isNaN(whtAmount.amount) &&
      whtAmount.amount.ToNumber() !== 0 &&
      whtAmount.amount.ToNumber() === transactionWhtTotal.ToNumber()
    ) {
      whtAmountType = whtAmount.whtType;
      break;
    }
  }
  return whtAmountType;
}

function GetIsCanCreateCombinedReceipt(transaction, payment) {
  let IsCanCreateCombinedReceipt = transaction.transactionStatus === Enums.InvoiceStatus.PaidOrAwaitReceipt;
  if (payment) {
    if (payment.paymentGroupList && payment.paymentGroupList.length > 1) {
      payment.paymentGroupList.forEach((paymentGroup) => {
        if (paymentGroup.referenceTransactionId > 0) {
          IsCanCreateCombinedReceipt = false;
        }
      });
    } else if (payment.paymentGroupList && payment.paymentGroupList.length == 1) {
      IsCanCreateCombinedReceipt = false;
    }
  }

  return IsCanCreateCombinedReceipt;
}

export const SuggestionPaymentAmount = (paymentTotal, paymentGroupTotal, paymentAmount) => {
  const paymentTotalNumber = paymentTotal ? paymentTotal.ToNumber() : 0;
  const paymentGroupTotalNumber = paymentGroupTotal ? paymentGroupTotal.ToNumber() : 0;
  const paymentAmountNumber = paymentAmount ? paymentAmount.ToNumber() : 0;
  const suggestedPaymentAmount = paymentTotalNumber - (paymentGroupTotalNumber - paymentAmountNumber);

  return suggestedPaymentAmount.FormatMoney();
};

export const CalculatePaymentAmount = (paymentAmount, oldPaymentTotal, newPaymentTotal) => {
  const paymentAmountNumber = paymentAmount ? paymentAmount.ToNumber() : 0;
  const oldPaymentTotalNumber = oldPaymentTotal ? oldPaymentTotal.ToNumber() : 0;
  const newPaymentTotalNumber = newPaymentTotal ? newPaymentTotal.ToNumber() : 0;

  return peakUtility
    .PeakOperatorSubtract(
      peakUtility.PeakOperatorAdd(paymentAmountNumber, oldPaymentTotalNumber),
      newPaymentTotalNumber
    )
    .FormatMoney();
};

export const SetSubAccountForPaymentTransactionChartAccount = async (paymentTransactionChartOfAccountList) => {
  const contactIdList = [];
  const productIdList = [];
  const chequeIdList = [];
  if (paymentTransactionChartOfAccountList && paymentTransactionChartOfAccountList.length > 0) {
    for (const paymentTransactionChartOfAccount of paymentTransactionChartOfAccountList) {
      if (paymentTransactionChartOfAccount.accountReferenceTypeId > 0) {
        if (paymentTransactionChartOfAccount.accountReferenceTypeId === Enums.JournalAccountReferenceType.Contact) {
          contactIdList.push(paymentTransactionChartOfAccount.accountReferenceId);
        } else if (
          paymentTransactionChartOfAccount.accountReferenceTypeId === Enums.JournalAccountReferenceType.ProductTemplate
        ) {
          productIdList.push(paymentTransactionChartOfAccount.accountReferenceId);
        } else if (
          paymentTransactionChartOfAccount.accountReferenceTypeId === Enums.JournalAccountReferenceType.Cheque
        ) {
          chequeIdList.push(paymentTransactionChartOfAccount.accountReferenceId);
        }
      }
    }
  }

  if (contactIdList.length > 0) {
    await store.dispatch("DoGetContactByContactIdList", contactIdList);
  }

  if (productIdList.length > 0) {
    await store.dispatch("DoGetProductTemplateByProductIdList", productIdList);
  }

  if (chequeIdList.length > 0) {
    await store.dispatch("DoGetChequeByIdList", chequeIdList);
  }

  if (paymentTransactionChartOfAccountList && paymentTransactionChartOfAccountList.length > 0) {
    const getContactModelList = store.getters.GetContactModelList;
    const getProductTemplateModelList = store.getters.GetProductTemplateModelList;
    const getChequeModelList = store.getters.GetChequeModelList;
    const getBankAccountList = store.getters.GetAllBankAccountList;
    for (const paymentTransactionChartOfAccount of paymentTransactionChartOfAccountList) {
      if (
        paymentTransactionChartOfAccount.accountReferenceId > 0 &&
        paymentTransactionChartOfAccount.accountReferenceTypeId > 0
      ) {
        switch (paymentTransactionChartOfAccount.accountReferenceTypeId) {
          case Enums.JournalAccountReferenceType.Contact:
            let contact = getContactModelList.find(
              (contact) => contact.id == paymentTransactionChartOfAccount.accountReferenceId
            );
            if (contact && contact.isArchived == false && contact.isDeleted == false) {
              paymentTransactionChartOfAccount.accountReferenceCode = contact.contactCode;
              paymentTransactionChartOfAccount.accountReferenceName = contact.contactName;
            }
            break;
          case Enums.JournalAccountReferenceType.ProductTemplate:
            let product = getProductTemplateModelList.find(
              (product) => product.id == paymentTransactionChartOfAccount.accountReferenceId
            );
            if (product && product.isArchived == false && product.isDeleted == false) {
              paymentTransactionChartOfAccount.accountReferenceCode = product.code;
              paymentTransactionChartOfAccount.accountReferenceName = product.name;
            }
            break;
          case Enums.JournalAccountReferenceType.Cheque:
            let cheque = getChequeModelList.find(
              (cheque) => cheque.id == paymentTransactionChartOfAccount.accountReferenceId
            );
            if (cheque) {
              paymentTransactionChartOfAccount.accountReferenceCode = cheque.chequeCode;
            }
            break;
          case Enums.JournalAccountReferenceType.BankAccount:
            let bankAccount = getBankAccountList.find(
              (bankAccount) => bankAccount.id == paymentTransactionChartOfAccount.accountReferenceId
            );
            if (bankAccount) {
              paymentTransactionChartOfAccount.accountReferenceCode = bankAccount.code;
            }
            break;
        }
      }
    }
  }
};

export const CoverPaymentGroupDetailToPaymentGroupCreate = async (paymentGroupDetail) => {
  const paymentGroupDefault = GetCreateTransactionPaymentGroupDefualt();
  if (paymentGroupDetail) {
    paymentGroupDefault.paymentGroupDate = paymentGroupDetail.paymentGroupDate;
    paymentGroupDefault.id = paymentGroupDetail.id;
    paymentGroupDefault.paymentTransactionBankAccountList = [];
    paymentGroupDefault.paymentTransactionBankAccountActived = true;
    if (
      paymentGroupDetail.paymentTransactionBankAccountList &&
      paymentGroupDetail.paymentTransactionBankAccountList.length > 0
    ) {
      for (const paymentTransactionBankAccount of paymentGroupDetail.paymentTransactionBankAccountList) {
        const paymentBankAccountTransaction = GetCreatePaymentTransactionBankAccountDefault();
        paymentBankAccountTransaction.id = paymentTransactionBankAccount.id;
        paymentBankAccountTransaction.bankAccountId = paymentTransactionBankAccount.bankAccountId;
        paymentBankAccountTransaction.paymentAmount = paymentTransactionBankAccount.paymentAmount.FormatMoney();
        paymentBankAccountTransaction.remark = paymentTransactionBankAccount.remark;
        paymentBankAccountTransaction.isCheque = paymentTransactionBankAccount.isCheque;

        if (paymentBankAccountTransaction.isCheque) {
          paymentBankAccountTransaction.cheque.id = paymentTransactionBankAccount.cheque.id;
          paymentBankAccountTransaction.cheque.chequeDate = paymentTransactionBankAccount.cheque.chequeDate;
          paymentBankAccountTransaction.cheque.branchNumber = paymentTransactionBankAccount.cheque.branchNumber;
          paymentBankAccountTransaction.cheque.accountNumber = paymentTransactionBankAccount.cheque.accountNumber;
          paymentBankAccountTransaction.cheque.chequeBankId = paymentTransactionBankAccount.cheque.chequeBankId;
          paymentBankAccountTransaction.cheque.chequeNumber = paymentTransactionBankAccount.cheque.chequeNumber;
        }

        paymentGroupDefault.paymentTransactionBankAccountList.push(paymentBankAccountTransaction);
      }
    }
    paymentGroupDefault.paymentTransactionChartOfAccountList = [];
    paymentGroupDefault.paymentTransactionChartAccountActived = true;
    if (
      paymentGroupDetail.paymentTransactionChartOfAccountList &&
      paymentGroupDetail.paymentTransactionChartOfAccountList.length > 0
    ) {
      for (const paymentTransactionChartOfAccount of paymentGroupDetail.paymentTransactionChartOfAccountList) {
        const paymentTransactionChartAccount = GetCreatePaymentTransactionChartAccountDefault();
        paymentTransactionChartAccount.id = paymentTransactionChartOfAccount.id;
        paymentTransactionChartAccount.accountId = paymentTransactionChartOfAccount.accountId;
        paymentTransactionChartAccount.remark = paymentTransactionChartOfAccount.remark;
        paymentTransactionChartAccount.accountReferenceId = paymentTransactionChartOfAccount.accountReferenceId;
        paymentTransactionChartAccount.accountReferenceTypeId = paymentTransactionChartOfAccount.accountReferenceTypeId;
        if (paymentTransactionChartOfAccount.paymentAmount < 0) {
          paymentTransactionChartAccount.adjustValue = Enums.TransferFeeDeductType.WithDrawalAccount;
          paymentTransactionChartAccount.paymentAmount = (
            paymentTransactionChartOfAccount.paymentAmount * -1
          ).FormatMoney();
        } else {
          paymentTransactionChartAccount.paymentAmount = paymentTransactionChartOfAccount.paymentAmount.FormatMoney();
          paymentTransactionChartAccount.adjustValue = Enums.TransferFeeDeductType.DepositeAccount;
        }
        paymentGroupDefault.paymentTransactionChartOfAccountList.push(paymentTransactionChartAccount);
      }

      await SetSubAccountForPaymentTransactionChartAccount(paymentGroupDefault.paymentTransactionChartOfAccountList);
    }
    paymentGroupDefault.paymentTransactionDocumentList = [];
    paymentGroupDefault.paymentTransactionDocumentActived = true;
    if (
      paymentGroupDetail.paymentTransactionDocumentList &&
      paymentGroupDetail.paymentTransactionDocumentList.length > 0
    ) {
      for (const paymentTransactionReferenceRaw of paymentGroupDetail.paymentTransactionDocumentList) {
        const paymentTransactionDocument = GetCreatePaymentTransactionDocumentDefault();
        paymentTransactionDocument.id = paymentTransactionReferenceRaw.id;
        paymentTransactionDocument.transactionType = {
          value: paymentTransactionReferenceRaw.transactionType,
        };
        paymentTransactionDocument.transactionId = paymentTransactionReferenceRaw.transactionId;
        paymentTransactionDocument.transactionNumber = paymentTransactionReferenceRaw.transactionNumber;
        paymentTransactionDocument.paymentAmount = paymentTransactionReferenceRaw.paymentAmount.FormatMoney();
        paymentTransactionDocument.remark = paymentTransactionReferenceRaw.remark;

        paymentGroupDefault.paymentTransactionDocumentList.push(paymentTransactionDocument);
      }
    }

    paymentGroupDefault.whtPayment = {
      id: paymentGroupDetail.whtPayment.id,
      isWht: paymentGroupDetail.whtPayment.id > 0,
      pndTypeId: paymentGroupDetail.whtPayment.pndType,
      whtAmountTypeId: paymentGroupDetail.whtPayment.whtAmountType,
      whtAmount: paymentGroupDetail.whtPayment.whtAmount.FormatMoney(),
      whtDeductType: Enums.WhtDeductType.None,
      disabled: false,
      hidden: false,
    };
  }
  return paymentGroupDefault;
};

export const GetPaymentSummaryFromPaymentTransaction = (payment) => {
  let paymentTransactionChartAccount = 0;
  let paymentTransactionDocument = 0;
  let paymentTransactionBankAccount = 0;
  let whtPayment = 0;
  let paymentGroupTotal = 0;
  if (payment && payment.paymentGroupList && payment.paymentGroupList.length > 0) {
    paymentGroupTotal = payment.paymentAllGroupTotal.ToNumber();
    payment.paymentGroupList.forEach((paymentGroup) => {
      if (paymentGroup.paymentTransactionBankAccountList && paymentGroup.paymentTransactionBankAccountList.length > 0) {
        paymentGroup.paymentTransactionBankAccountList.forEach((paymentTransaction) => {
          paymentTransactionBankAccount += paymentTransaction.paymentAmount.ToNumber();
        });
      }

      if (
        paymentGroup.paymentTransactionChartOfAccountList &&
        paymentGroup.paymentTransactionChartOfAccountList.length > 0
      ) {
        paymentGroup.paymentTransactionChartOfAccountList.forEach((paymentTransaction) => {
          paymentTransactionChartAccount += peakUtility.PeakOperatorMultiply(
            paymentTransaction.adjustValue == Enums.TransferFeeDeductType.WithDrawalAccount ? -1 : 1,
            paymentTransaction.paymentAmount.ToNumber()
          );
        });
      }

      if (paymentGroup.paymentTransactionDocumentList && paymentGroup.paymentTransactionDocumentList.length > 0) {
        paymentGroup.paymentTransactionDocumentList.forEach((paymentTransaction) => {
          paymentTransactionDocument += paymentTransaction.paymentAmount.ToNumber();
        });
      }

      if (paymentGroup.whtPayment) {
        whtPayment = paymentGroup.whtPayment.whtAmount.ToNumber();
      }
    });
  }
  return {
    paymentTransactionChartAccount,
    paymentTransactionDocument,
    paymentTransactionBankAccount,
    whtPayment,
    paymentGroupTotal,
  };
};
export default {
  GetCreateTransactionPaymentGroupDefualt(isPaymentActive = true) {
    return GetCreateTransactionPaymentGroupDefualt((isPaymentActive = true));
  },
  GetCreatePaymentTransactionBankAccountDefault() {
    return GetCreatePaymentTransactionBankAccountDefault();
  },
  GetCreatePaymentTransactionDocumentDefault() {
    return GetCreatePaymentTransactionDocumentDefault();
  },
  GetCreatePaymentTransactionChartAccountDefault() {
    return GetCreatePaymentTransactionChartAccountDefault();
  },
  CalculateAllPaymentGroupSummary(payment) {
    return CalculateAllPaymentGroupSummary(payment);
  },
  ValidationAllPaymentGroup(transaction, transactionType, financeType) {
    ValidationAllPaymentGroup(transaction, transactionType, financeType);
  },
  CalculateWhtAmount(transactionNetAmount, subTotalForCalculateWht, paymentGroup) {
    return CalculateWhtAmount(transactionNetAmount, subTotalForCalculateWht, paymentGroup);
  },
  OnChangeWht(paymentGroup, isFromEvent = false, isReturnWhtAmountToPayment = false) {
    return OnChangeWht(paymentGroup, isFromEvent, isReturnWhtAmountToPayment);
  },
  GetSuggestionPndType(transaction, accountListForMap) {
    return GetSuggestionPndType(transaction, accountListForMap);
  },
  GetPaymentInOutFlowType(transaction) {
    return GetPaymentInOutFlowType(transaction.transactionType, transaction.financeType);
  },
  GetPaymentInOutFlowTypeByTransactionTypeAndFinanceType(transactionType, financeType) {
    return GetPaymentInOutFlowType(transactionType, financeType);
  },
  GetPaymentWhtOption() {
    return GetPaymentWhtOption();
  },
  GetWhtPaymentPercent(subTotalForCalculateWht, transactionWhtTotal, transactionNetAmount, paymentNetAmount) {
    return GetWhtPaymentPercent(subTotalForCalculateWht, transactionWhtTotal, transactionNetAmount, paymentNetAmount);
  },
  GetCreateTransactionPaymentDefualt(isPaymentActive = true) {
    return GetCreateTransactionPaymentDefualt(isPaymentActive);
  },
  GetIsCanCreateCombinedReceipt(transaction, payment) {
    return GetIsCanCreateCombinedReceipt(transaction, payment);
  },
  GetWhtPercentFromWhtAmountType(whtAmountTypeId) {
    return GetWhtPercentFromWhtAmountType(whtAmountTypeId);
  },
  CalculateWhtByPercent(transactionNetAmount, subTotalForCalculateWht, paymentNetAmount, whtPercent) {
    return CalculateWhtByPercent(transactionNetAmount, subTotalForCalculateWht, paymentNetAmount, whtPercent);
  },
};
